import { Box, Skeleton, Typography } from "@mui/material"
import type { FC } from "react"

import { UOM_RENDER_PRECISION } from "@/constants/formats"
import { formatNumber } from "@/utils/index"

interface CustomerPurchaseOrderLineItemSubtotalProps {
  label: string
  total: number
  target: number
  isOverTotal: boolean
  isLoading: boolean
  "data-testid": string
}

export const CustomerPurchaseOrderLineItemSubtotal: FC<CustomerPurchaseOrderLineItemSubtotalProps> = ({
  label,
  total,
  target,
  isOverTotal,
  isLoading,
  "data-testid": dataTestId,
}) => (
  <Box
    className='flex min-w-[200px] flex-col items-start gap-2 rounded-md border border-gray-300 bg-gray-100 p-6'
    data-testid={dataTestId}
  >
    <Typography variant='caption' className='text-primary'>
      {label}
    </Typography>
    {isLoading ? (
      <Skeleton variant='text' className='w-full' sx={{ fontSize: "h4.fontSize" }} />
    ) : (
      <Typography variant='h4' className='font-bold text-gray-700'>
        <Typography component='span' variant='inherit' className={isOverTotal ? "text-tertiary-yellow-900" : undefined}>
          {formatNumber(total, UOM_RENDER_PRECISION, 0)}
        </Typography>
        /{formatNumber(target, UOM_RENDER_PRECISION, 0)}
      </Typography>
    )}
  </Box>
)
